exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\n  padding: 14px; }\n\n.modal-body .inner-form {\n  padding: 14px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/system/departments/popup-modal.component.scss
// module id = ../../../../../src/app/views/system/departments/popup-modal.component.scss
// module chunks = main